export default __webpack_public_path__ + "static/media/Thumb_Hairstyle_01.e3dba831.png";